/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var TransitionGroup = require("react-transition-group/TransitionGroup");
var CSSTransition = require("react-transition-group/CSSTransition");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./ContentFade.css'); }
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-contentFade");
var ContentFade = /** @class */ (function (_super) {
    tslib_1.__extends(ContentFade, _super);
    function ContentFade() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentHeight: undefined
        };
        return _this;
    }
    ContentFade.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        var currentChild = React.Children.only(this.props.children);
        var nextChild = React.Children.only(nextProps.children);
        if (nextChild.key === currentChild.key) {
            return;
        }
        if (this.content) {
            this.setState({
                currentHeight: this.content.offsetHeight
            });
            clearTimeout(this.resetHeight);
            this.resetHeight = window.setTimeout(function () {
                if (!_this.content) {
                    return;
                }
                var newNode = _this.content.querySelector("." + moduleClassName("enter"));
                if (newNode) {
                    _this.setState({
                        currentHeight: newNode.offsetHeight
                    });
                    _this.resetHeight = window.setTimeout(function () {
                        _this.setState({
                            currentHeight: false
                        });
                    }, 250);
                }
                else {
                    _this.content.style.height = "auto";
                }
            }, 250);
        }
    };
    ContentFade.prototype.componentWillUnmount = function () {
        if (this.resetHeight) {
            clearTimeout(this.resetHeight);
        }
    };
    ContentFade.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className;
        return (React.createElement("div", { ref: function (element) { return (_this.content = element); }, className: classnames(moduleClassName(), this.state.currentHeight !== false &&
                moduleClassName("isTransitioning"), className), style: {
                height: this.state.currentHeight || "auto"
            } },
            React.createElement(TransitionGroup, null, !!children &&
                React.Children.map(children, function (child, index) {
                    if (!child) {
                        return null;
                    }
                    return (React.createElement(CSSTransition, { classNames: moduleClassName(), timeout: 750, mountOnEnter: true, unmountOnExit: true, key: "key-" + index }, React.cloneElement(child)));
                }))));
    };
    ContentFade.propTypes = {
        className: PropTypes.string
    };
    return ContentFade;
}(React.Component));
exports.ContentFade = ContentFade;